import React from "react";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { Box, Button } from "@mui/material";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import useConfig from "hooks/useConfig";

const DateTimePickerComponent = ({
  label = "",
  value,
  setValue = () => { },
  ...props
}) => {
  const { t } = useTranslation();
  const { locale } = useConfig();

  return (
    <LocalizationProvider
      locale={locale ? locale : "it"}
      dateAdapter={AdapterLuxon}
    >
      <DateTimePicker
        ToolbarComponent={(props) => (
          <Box {...props} sx={{ width: "100%", zIndex: 20 }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => setValue(DateTime.now())}
            >
              {t("Current Date")}
            </Button>
          </Box>
        )}
        label={label}
        ampm={false}
        renderInput={(params) => (
          <TextField
            size="small"
            {...params}
            margin="normal"
            sx={{ width: "100%" }}
          />
        )}
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
        }}
        {...props}
        showToolbar={true}

      />
    </LocalizationProvider>
  );
};

export default DateTimePickerComponent;
